import type { Answers } from '../types/surveyQuestion';

/**
 * Coerce an answer value to a single string. Multi-select (checkbox) answers are
 * `string[]`, but the consumers that call this — the legacy assigned-screener
 * payload, pre-diabetes, PHQ/GAD — are ALL single-select and never actually
 * receive an array. This exists only to satisfy the widened `Answers` value type
 * at those call sites; if an array ever did arrive, its first value is taken.
 */
export function toSingleAnswerValue(value: Answers[string]): string {
  return Array.isArray(value) ? (value[0] ?? '') : value;
}
